module.exports = __webpack_public_path__ + "img/galeria-marinas2.91e523c3.jpg";